import { useEffect, useState } from "react";
import Select from "react-select";
import {
  updateComponentStyle,
  updateStructureComponent,
} from "../../../../../store/reducers/builderReducers/structure/structureActions";
import { TextEditorSelectStyle } from "../../../ReactSelectStyle/ReactSelectStyle";
import { useAppSelector } from "../../../../../store/hooks";
import React from "react";
interface Props {
  id: number;
  triggerResize: () => void;
}

export default function SpacingMenu({ id, triggerResize }: Props) {
  console.log("SpacingMenu");
  const component = useAppSelector(
    (state) => state.builder.structure.components[id]
  )!;
  const [expanded, setExpanded] = useState(false);
  const [itemEmpty, setItemEmpty] = useState<string[]>([]);

  const marginUnits = [
    { value: "px", label: "px" },
    { value: "em", label: "em" },
    { value: "rem", label: "rem" },
    { value: "%", label: "%" },
    { value: "auto", label: "auto" },
  ];
  const paddingUnits = [
    { value: "px", label: "px" },
    { value: "em", label: "em" },
    { value: "rem", label: "rem" },
    { value: "%", label: "%" },
  ];

  // TODO make better
  const spacing = {
    paddingLeft:
      component.attributes &&
      component.attributes.styles["paddingLeft"] !== undefined
        ? component.attributes.styles["paddingLeft"]
        : "0px",
    paddingRight:
      component.attributes &&
      component.attributes.styles["paddingRight"] !== undefined
        ? component.attributes.styles["paddingRight"]
        : "0px",
    paddingBottom:
      component.attributes &&
      component.attributes.styles["paddingBottom"] !== undefined
        ? component.attributes.styles["paddingBottom"]
        : "0px",
    paddingTop:
      component.attributes &&
      component.attributes.styles["paddingTop"] !== undefined
        ? component.attributes.styles["paddingTop"]
        : "0px",
    marginLeft:
      component.attributes &&
      component.attributes.styles["marginLeft"] !== undefined
        ? component.attributes.styles["marginLeft"]
        : "0px",
    marginRight:
      component.attributes &&
      component.attributes.styles["marginRight"] !== undefined
        ? component.attributes.styles["marginRight"]
        : "0px",
    marginBottom:
      component.attributes &&
      component.attributes.styles["marginBottom"] !== undefined
        ? component.attributes.styles["marginBottom"]
        : "0px",
    marginTop:
      component.attributes &&
      component.attributes.styles["marginTop"] !== undefined
        ? component.attributes.styles["marginTop"]
        : "0px",
  };

  useEffect(() => {
    triggerResize();
  }, []);

  return (
    <>
      <div
        className={
          "d-flex   spacing-menu-row spacing-menu-items" +
          (expanded ? " b-pb-2" : "")
        }
      >
        {!expanded && (
          <div>
            <div
              style={{
                marginBottom: "15px",
                marginTop: "5px",
                display: "grid",
                gap: "4px",
                padding: "0px",
                gridTemplateColumns: "55px 40px 40px 40px 40px 50px",
              }}
            >
              <span>Margin:</span>
              {["Left", "Top", "Right", "Bottom"].map((x, i) => (
                <div
                  key={x}
                  className={"" + (i === 0 ? " " : "")}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    alignItems: "center",
                    gap: "7px",
                  }}
                >
                  {["margin"].map((y) => {
                    return (
                      <div key={y}>
                        <input
                          type="number"
                          className="global-editor__input builder-input spacing-menu_input"
                          size={1}
                          value={
                            itemEmpty.includes(y + x)
                              ? ""
                              : (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                          }
                          onChange={(ev) => {
                            if (isNaN(ev.target.value as any)) return;

                            if (ev.target.value == "")
                              setItemEmpty((a) => [...a, y + x]);
                            else
                              setItemEmpty((a) => a.filter((s) => s !== y + x));
                            (spacing as any)[y + x] =
                              (ev.target.value === "" ? 0 : ev.target.value) +
                              "px";
                            updateComponentStyle(id, spacing);
                          }}
                        />

                        <span
                          style={{
                            fontSize: "9px",
                            textAlign: "center",
                            textTransform: "uppercase",
                            color: "#aaa",
                          }}
                        >
                          {x === "Bottom" ? "BOT" : x}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ))}

              <div style={{ width: "35px" }}>
                <Select
                  menuPosition="fixed"
                  className="m-0 spacing-menu_input"
                  isSearchable={false}
                  styles={TextEditorSelectStyle}
                  noOptionsMessage={({}) => ""}
                  options={marginUnits}
                  value={marginUnits.find(
                    (x) =>
                      x.value ===
                      (spacing["marginTop"]
                        .toString()
                        .match("[A-Za-z%]+$")![0] ?? "px")
                  )}
                  onChange={(option: any) => {
                    let newVal =
                      Number(
                        spacing.marginTop.toString().match(/(-\d+|\d+)/)![0]
                      ) + option!.value;
                    Object.entries(spacing).forEach(([key, value]) => {
                      if (key.includes("margin")) {
                        spacing[key as keyof typeof spacing] = newVal;
                      }
                    });
                    updateComponentStyle(id, spacing);
                  }}
                  placeholder=""
                ></Select>
              </div>
            </div>

            <div
              style={{
                marginBottom: "0px",
                marginTop: "5px",
                display: "grid",
                gap: "4px",
                padding: "0px",
                gridTemplateColumns: "55px 40px 40px 40px 40px 50px",
              }}
            >
              <span>Padding:</span>
              {["Left", "Top", "Right", "Bottom"].map((x, i) => (
                <div
                  key={x}
                  className={"" + (i === 0 ? " " : "")}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    alignItems: "center",
                    gap: "7px",
                  }}
                >
                  {["padding"].map((y) => {
                    return (
                      <div key={y}>
                        <input
                          type="number"
                          className="global-editor__input builder-input spacing-menu_input"
                          size={1}
                          value={
                            itemEmpty.includes(y + x)
                              ? ""
                              : (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                          }
                          onChange={(ev) => {
                            if (isNaN(ev.target.value as any)) return;

                            if (ev.target.value == "")
                              setItemEmpty((a) => [...a, y + x]);
                            else
                              setItemEmpty((a) => a.filter((s) => s !== y + x));
                            (spacing as any)[y + x] =
                              (ev.target.value === "" ? 0 : ev.target.value) +
                              "px";
                            updateComponentStyle(id, spacing);
                          }}
                        />

                        <span
                          style={{
                            fontSize: "9px",
                            textAlign: "center",
                            textTransform: "uppercase",
                            color: "#aaa",
                          }}
                        >
                          {x === "Bottom" ? "BOT" : x}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ))}

              <div style={{ width: "35px" }}>
                <Select
                  menuPosition="fixed"
                  className="m-0 spacing-menu_input"
                  isSearchable={false}
                  styles={TextEditorSelectStyle}
                  value={paddingUnits.find(
                    (x) =>
                      x.value ===
                      (spacing["paddingTop"]
                        .toString()
                        .match("[A-Za-z%]+$")![0] ?? "px")
                  )}
                  options={paddingUnits}
                  onChange={(option: any) => {
                    let newVal =
                      Number(
                        spacing.paddingTop.toString().match(/(-\d+|\d+)/)![0]
                      ) + option!.value;
                    Object.entries(spacing).forEach(([key, value]) => {
                      if (key.includes("padding")) {
                        spacing[key as keyof typeof spacing] = newVal;
                      }
                    });
                    updateComponentStyle(id, spacing);
                  }}
                  placeholder=""
                ></Select>
              </div>
            </div>
          </div>
        )}
        {/* <div>afsdase</div> */}

        {/* {!expanded && (
          <>
            <div>Margin:</div>
            <div className="d-flex b-px-0">
              <span
                className="b-px-1"
                onClick={() => {
                  let newVal =
                    Number(
                      spacing.marginTop.toString().match(/(-\d+|\d+)/)![0]
                    ) -
                    1 +
                    marginUnits.find(
                      (x) =>
                        x.value ===
                        (spacing["marginTop"]
                          .toString()
                          .match("[A-Za-z%]+$")![0] ?? "px")
                    )!.value;
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("margin")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      setItemEmpty((a) => a.filter((x) => x !== key));
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              >
                {" "}
                -{" "}
              </span>
              <input
                className="global-editor__input builder-input"
                size={1}
                value={
                  itemEmpty.includes("marginTop")
                    ? ""
                    : spacing.marginTop.toString().match(/(-\d+|\d+)/)![0] ?? ""
                }
                onChange={(ev) => {
                  if (isNaN(ev.target.value as any)) return;

                  let newVal =
                    (ev.target.value == "" ? 0 : ev.target.value) +
                    marginUnits.find(
                      (x) =>
                        x.value ===
                        (spacing["marginTop"]
                          .toString()
                          .match("[A-Za-z%]+$")![0] ?? "px")
                    )!.value;
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("margin")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      if (ev.target.value == "") {
                        setItemEmpty((a) => [...a, key]);
                      } else {
                        setItemEmpty((a) => a.filter((x) => x !== key));
                      }
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              />
              <span
                className="b-px-1"
                onClick={() => {
                  let newVal =
                    Number(
                      spacing.marginTop.toString().match(/(-\d+|\d+)/)![0]
                    ) +
                    1 +
                    marginUnits.find(
                      (x) =>
                        x.value ===
                        (spacing["marginTop"]
                          .toString()
                          .match("[A-Za-z%]+$")![0] ?? "px")
                    )!.value;
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("margin")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      setItemEmpty((a) => a.filter((x) => x !== key));
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              >
                {" "}
                +{" "}
              </span>
              <div style={{ width: "35px" }}>
                <Select
                  menuPosition="fixed"
                  className="m-0"
                  isSearchable={false}
                  styles={TextEditorSelectStyle}
                  noOptionsMessage={({}) => ""}
                  options={marginUnits}
                  value={marginUnits.find(
                    (x) =>
                      x.value ===
                      (spacing["marginTop"]
                        .toString()
                        .match("[A-Za-z%]+$")![0] ?? "px")
                  )}
                  onChange={(option: any) => {
                    let newVal =
                      Number(
                        spacing.marginTop.toString().match(/(-\d+|\d+)/)![0]
                      ) + option!.value;
                    Object.entries(spacing).forEach(([key, value]) => {
                      if (key.includes("margin")) {
                        spacing[key as keyof typeof spacing] = newVal;
                      }
                    });
                    updateComponentStyle(id, spacing);
                  }}
                  placeholder=""
                ></Select>
              </div>
            </div>
            <div className="b-ms-3 b-me-1" style={{ minWidth: "unset" }}>
              Padding:
            </div>
            <div className="d-flex b-px-0">
              <div
                onClick={() => {
                  let newVal =
                    Number(
                      spacing.paddingTop.toString().match(/(-\d+|\d+)/)![0]
                    ) -
                    1 +
                    (spacing["paddingTop"]
                      .toString()
                      .match("[A-Za-z%]+$")![0] ?? "px");
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("padding")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      setItemEmpty((a) => a.filter((x) => x !== key));
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              >
                {" "}
                -{" "}
              </div>
              <input
                className="global-editor__input builder-input"
                size={1}
                value={
                  itemEmpty.includes("paddingTop")
                    ? ""
                    : spacing.paddingTop.toString().match(/(-\d+|\d+)/)![0]
                }
                onChange={(ev) => {
                  if (isNaN(ev.target.value as any)) return;

                  let newVal =
                    (ev.target.value == "" ? 0 : ev.target.value) +
                    paddingUnits.find(
                      (x) =>
                        x.value ===
                        (spacing["paddingTop"]
                          .toString()
                          .match("[A-Za-z%]+$")![0] ?? "px")
                    )!.value;
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("padding")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      if (ev.target.value == "") {
                        setItemEmpty((a) => [...a, key]);
                      } else {
                        setItemEmpty((a) => a.filter((x) => x !== key));
                      }
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              />
              <div
                className="b-px-1"
                onClick={() => {
                  let newVal =
                    Number(
                      spacing.paddingTop.toString().match(/(-\d+|\d+)/)![0]
                    ) +
                    1 +
                    (spacing["paddingTop"]
                      .toString()
                      .match("[A-Za-z%]+$")![0] ?? "px");
                  Object.entries(spacing).forEach(([key, value]) => {
                    if (key.includes("padding")) {
                      spacing[key as keyof typeof spacing] = newVal;
                      setItemEmpty((a) => a.filter((x) => x !== key));
                    }
                  });
                  updateComponentStyle(id, spacing);
                }}
              >
                {" "}
                +{" "}
              </div>
              <div style={{ width: "35px" }}>
                <Select
                  menuPosition="fixed"
                  className="m-0"
                  isSearchable={false}
                  styles={TextEditorSelectStyle}
                  value={paddingUnits.find(
                    (x) =>
                      x.value ===
                      (spacing["paddingTop"]
                        .toString()
                        .match("[A-Za-z%]+$")![0] ?? "px")
                  )}
                  options={paddingUnits}
                  onChange={(option: any) => {
                    let newVal =
                      Number(
                        spacing.paddingTop.toString().match(/(-\d+|\d+)/)![0]
                      ) + option!.value;
                    Object.entries(spacing).forEach(([key, value]) => {
                      if (key.includes("padding")) {
                        spacing[key as keyof typeof spacing] = newVal;
                      }
                    });
                    updateComponentStyle(id, spacing);
                  }}
                  placeholder=""
                ></Select>
              </div>
            </div>
          </>
        )} */}
        {expanded && (
          <>
            {["Left", "Top", "Right", "Bottom"].map((x, i) => (
              <div
                key={x}
                className={"b-px-1" + (i === 0 ? " " : "")}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                {["margin", "padding"].map((y) => {
                  return (
                    <div key={y} className="d-flex" style={{ gap: "5px" }}>
                      <div
                        style={{
                          width: "45px",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "11px",
                        }}
                      >
                        {y === "margin" ? `Margin ${x}` : `Padding ${x}`}
                      </div>
                      <div className="spacing-menu_input">
                        <div
                          style={{
                            fontSize: "15px",
                          }}
                          className="b-px-1 "
                          onClick={() => {
                            setItemEmpty((a) => a.filter((s) => s !== y + x));
                            (spacing as any)[y + x] =
                              Number(
                                (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                              ) -
                              1 +
                              ((spacing as any)[y + x].match(
                                "[A-Za-z%]+$"
                              )[0] ?? "px");
                            updateComponentStyle(id, spacing);
                          }}
                        >
                          {" "}
                          −{" "}
                        </div>
                        <input
                          className="global-editor__input builder-input"
                          size={1}
                          value={
                            itemEmpty.includes(y + x)
                              ? ""
                              : (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                          }
                          onChange={(ev) => {
                            if (isNaN(ev.target.value as any)) return;

                            if (ev.target.value == "")
                              setItemEmpty((a) => [...a, y + x]);
                            else
                              setItemEmpty((a) => a.filter((s) => s !== y + x));
                            (spacing as any)[y + x] =
                              (ev.target.value === "" ? 0 : ev.target.value) +
                              "px";
                            updateComponentStyle(id, spacing);
                          }}
                        />
                        <div
                          className="b-px-1 "
                          style={{
                            fontSize: "15px",
                          }}
                          onClick={() => {
                            setItemEmpty((a) => a.filter((s) => s !== y + x));
                            (spacing as any)[y + x] =
                              Number(
                                (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                              ) +
                              1 +
                              ((spacing as any)[y + x].match(
                                "[A-Za-z%]+$"
                              )[0] ?? "px");
                            updateComponentStyle(id, spacing);
                          }}
                        >
                          {" "}
                          +{" "}
                        </div>
                      </div>
                      <div
                        style={{ width: "35px" }}
                        className="spacing-menu_input"
                      >
                        <Select
                          menuPosition="fixed"
                          className="m-0"
                          isSearchable={false}
                          styles={TextEditorSelectStyle}
                          value={
                            y === "padding"
                              ? paddingUnits.find(
                                  (l) =>
                                    l.value ===
                                    ((spacing as any)[y + x].match(
                                      "[A-Za-z%]+$"
                                    )[0] ?? "px")
                                )
                              : marginUnits.find(
                                  (l) =>
                                    l.value ===
                                    ((spacing as any)[y + x].match(
                                      "[A-Za-z%]+$"
                                    )[0] ?? "px")
                                )
                          }
                          options={y === "padding" ? paddingUnits : marginUnits}
                          onChange={(option: any) => {
                            (spacing as any)[y + x] =
                              Number(
                                (spacing as any)[y + x].match(/(-\d+|\d+)/)[0]
                              ) + option.value;
                            updateComponentStyle(id, spacing);
                          }}
                          placeholder=""
                        ></Select>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </>
        )}
        {/* <div className="col-1 text-end flex-grow-1 align-self-start">
          <MoreHorizOutlined
            onClick={() => {
              setExpanded(!expanded);
              setTimeout(() => {
                triggerResize();
              }, 300);
            }}
            style={{ fontSize: "18px" }}
          />
        </div> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingBottom: "4px",
            gap: "8px",
          }}
        >
          <span style={{ minWidth: "50px", fontSize: "12px" }}>Z-Index:</span>
          <input
            type="number"
            className="global-editor__input builder-input spacing-menu_input"
            size={1}
            style={{ width: "60px" }}
            value={
              component.attributes.styles.zIndex !== undefined &&
              component.attributes.styles.zIndex !== "auto"
                ? component.attributes.styles.zIndex.toString()
                : ""
            }
            placeholder="auto"
            onChange={(ev) => {
              if (ev.target.value === "") {
                updateStructureComponent(
                  id,
                  "attributes.styles.zIndex",
                  "auto"
                );
              } else {
                const value = parseInt(ev.target.value);
                if (!isNaN(value)) {
                  // Set position to relative when z-index is set, since z-index only works on positioned elements
                  updateStructureComponent(
                    id,
                    "attributes.styles.position",
                    "relative"
                  );
                  updateStructureComponent(
                    id,
                    "attributes.styles.zIndex",
                    value
                  );
                }
              }
            }}
          />
        </div>
      </div>
    </>
  );
}
